var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "#B8B8B8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1057,
    transform: "translate(-1085 -419)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: -1085,
    y: -419,
    width: 1920,
    height: 1057,
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -432,
    y: -186,
    width: 863,
    height: 589,
    rx: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53046 0H36.4695C40.0716 0 43 2.91906 43 6.53046V36.4695C43 40.0716 40.0809 43 36.4695 43H6.53046C2.92842 43 0 40.0809 0 36.4695V6.53046C0 2.92842 2.91906 0 6.53046 0Z",
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9906 18.7308V37.1339C42.9906 40.3711 40.371 42.9908 37.1338 42.9908H5.85683C2.61967 42.9908 0 40.3711 0 37.1339V22.9316C3.79852 25.9536 13.3697 31.7262 21.5 21.4908C27.3943 14.0809 36.245 15.3439 42.9906 18.7308Z",
    fill: "url(#paint1_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48708 15.4561C12.0397 15.4561 14.1089 13.3868 14.1089 10.8342C14.1089 8.28167 12.0397 6.2124 9.48708 6.2124C6.9345 6.2124 4.86523 8.28167 4.86523 10.8342C4.86523 13.3868 6.9345 15.4561 9.48708 15.4561Z",
    fill: "url(#paint2_linear_0_1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 1.91189,
    y1: 1.91516,
    x2: 41.0788,
    y2: 41.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 7.64092,
    y1: 15.2939,
    x2: 37.4497,
    y2: 45.1026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83E2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 6.22232,
    y1: 7.56948,
    x2: 12.7537,
    y2: 14.0999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83E2FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1057,
    fill: "white",
    transform: "translate(-1085 -419)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoImg);
export default __webpack_public_path__ + "static/media/photo_img.1ff62f298d8be5d196d9dac2237f44e8.svg";
export { ForwardRef as ReactComponent };